export default {
  data() {
    //客户级别
    const level = [
      {
        value: 1,
        label: 'AAA',
      },
      {
        value: 2,
        label: 'AA+',
      },
      {
        value: 3,
        label: 'AA',
      },
      {
        value: 4,
        label: 'AA-',
      },
      {
        value: 5,
        label: 'A+',
      },
      {
        value: 6,
        label: 'A',
      },
      {
        value: 7,
        label: 'A-',
      },
      {
        value: 8,
        label: 'BBB',
      },
      {
        value: 9,
        label: 'BB',
      },
      {
        value: 10,
        label: 'B',
      },
    ]
    const shareholderNatureList = [
      {
        value: 1,
        label: '上市公司',
      },
      {
        value: 2,
        label: '央企、国企',
      },
      {
        value: 3,
        label: '股份有限公司',
      },
      {
        value: 4,
        label: '有限责任公司',
      },
      {
        value: 5,
        label: '其他（私人等）',
      },
    ]
    const regionLevelList = [
      {
        label: '绿色',
        value: 1,
      },
      {
        label: '黄色',
        value: 2,
      },
      {
        label: '红色',
        value: 3,
      },
    ]
    return {
      baseSchema: {
        name: {
          label: '企业名称',
        },
        code: {
          label: '客户编码',
        },
        geo: {
          label: 'Geo',
        },
        address: {
          label: '公司地址',
        },
        customerType: {
          label: '客户类型',
        },
        commerce: {
          label: '联想商务',
        },
        region: {
          label: '大区 / 模式',
        },
        business: {
          label: '业务类型',
        },
      },
      baseSourceData: {
        name: '',
        code: '',
        geo: '',
        address: '',
        customerType: '',
        commerce: '',
        region: '',
        business: '',
      },
      extraSchema: {
        legalPerson: {
          label: '企业法人',
        },
        legalPersonCard: {
          label: '法人身份证信息',
        },
        shareholder: {
          label: '企业股东',
        },
        shareholderCard: {
          label: '股东身份证信息',
        },
        registerMoney: {
          label: '注册资本(元)',
        },
        shareholderNature: {
          label: '股东性质',
          filter: value => {
            if (value) {
              return shareholderNatureList.filter(v => v.value == value)[0]
                .label
            }
          },
        },
        registerCode: {
          label: '客户注册号',
        },
        lastRefundAvgDays: {
          label: '上财年加权平均回款天数',
        },
        lastExpiryTimes: {
          label: '上财年逾期次数',
        },
        lastExpiryRate: {
          label: '近三财年3天以上逾期率(%)',
        },
        isExpiryRisk: {
          label: '上财年是否出现真实逾期风险',
        },
        isExpiry: {
          label: '目前是否存在真实逾期',
        },
        purchasePlan: {
          label: '未来一年联想直接采购预估额(元)',
        },
        purchase: {
          label: '近三年进货额(元)',
        },
        purchaseRateIncrement: {
          label: '联想直接采购额年增长率(%)',
        },
        level: {
          label: '客户级别',
          filter: value => {
            if (value) {
              return level.filter(v => v.value == value)[0].label
            }
          },
        },
        industryGroup: {
          label: '二级行业',
        },
        regionLevel: {
          label: '地域风险级别',
          filter: value => {
            if (value) {
              return regionLevelList.filter(v => v.value == value)[0].label
            }
          },
        },
        establishYear: {
          label: '成立时间',
        },
        coopTime: {
          label: '合作年限',
        },
        actualReceipt: {
          label: '实收资本(元)',
        },
      },
      extraSourceData: {
        legalPerson: '',
        legalPersonCard: '',
        shareholder: '',
        shareholderCard: '',
        registerMoney: '',
        shareholderNature: '',
        registerCode: '',
        lastRefundAvgDays: '',
        lastExpiryTimes: '',
        lastExpiryRate: '',
        isExpiryRisk: '',
        isExpiry: '',
        purchasePlan: '',
        purchase: '',
        purchaseRateIncrement: '',
        level: '',
        industryGroup: '',
        regionLevel: '',
        establishYear: '',
        coopTime: '',
        actualReceipt: '',
      },
    }
  },
}
